const numbersOnlyNormalizer = (value) => {
    const numbersOnly = new RegExp(/[^0-9]*/g);
    return value.replace(numbersOnly, '');
};

export default numbersOnlyNormalizer;
